import * as React from 'react';
import { dangerousInnerHtml } from '../utils';

interface ArticleProps {
	result: wpPost
}

export const ResultArticle: React.SFC<ArticleProps> = ({result}) => (
    <div className="tease tease-news tease-news--stacked tease-news--search-result-item">
        <a href={result.link} className="tease__mainlink"></a>
        <div className="tease-news__image-container tease-news__image-container--large">
            <img src={result.fimg_url}/>
        </div>

        <div className="tease-news__content">
            <div className="tease-news__content__padded">
                <a href="" className="article__tax-terms__item article__tax-terms__item--light tease-news__tag" dangerouslySetInnerHTML={dangerousInnerHtml(result.primary_category_name)}/>
                <a href={result.link}><h3 className="tease-news__title" dangerouslySetInnerHTML={dangerousInnerHtml(result.title.rendered)}/></a>
                <div className="tease-news__excerpt" dangerouslySetInnerHTML={dangerousInnerHtml(result.excerpt.rendered)}/>
                <p className="tease-news__writers">
                    <span>{result.formatted_date}</span>
                    {Array.isArray(result.writers) && (
                        <>
                            <span>&nbsp;| by&nbsp;</span>
                            {result.writers.map((writer, i) => {
                                if (writer?.guest_author) {
                                return (
                                    <>
                                        <span className="tease-news__writers-name">{writer.name}</span>
                                        {i !== result.writers.length - 1 ? ", " : ""}
                                    </>
                                );
                                }
                                return (
                                    <>
                                        <a className="tease-news__writers-name" href={writer.link}>{writer.name}</a>
                                        {i !== result.writers.length - 1 ? ", " : ""}
                                    </>
                                );
                            })}
                        </>
                    )}
                </p>
            </div>
        </div>
    </div>
)
